import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { invocationResultService } from '@/services/invocation-result-service';
import type { InvocationResult } from '@/types/core/invocation-result';
import type { UUID } from '@/utils/uuid';

import { sensitiveContentQueryKeys } from './query-keys';

/**
 * A run's stored result, read once the run has finished; null when it stored
 * none. It carries no sealed value, so it is an ordinary query.
 */
export function useInvocationResult(
  tenantId: UUID | undefined,
  connectorId: UUID | undefined,
  featureId: UUID | undefined,
  runSequence: number | undefined,
  finished: boolean
): UseQueryResult<InvocationResult | null, Error> {
  return useQuery<InvocationResult | null, Error>({
    queryKey: sensitiveContentQueryKeys.runResult(
      tenantId,
      connectorId,
      featureId,
      runSequence
    ),
    queryFn: () =>
      invocationResultService.get(
        tenantId as UUID,
        connectorId as UUID,
        featureId as UUID,
        runSequence as number
      ),
    enabled:
      finished &&
      !!tenantId &&
      !!connectorId &&
      !!featureId &&
      runSequence !== undefined,
  });
}
